export default __webpack_public_path__ + "static/media/geojit-logo.411aa2cb.png";